import { render, staticRenderFns } from "./dismissal_comment_box_toggle.vue?vue&type=template&id=62bd8a8d&"
import script from "./dismissal_comment_box_toggle.vue?vue&type=script&lang=js&"
export * from "./dismissal_comment_box_toggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports